import NatureDash from './NatureDashboard';

export const NatureDashboard = NatureDash;
